import { v2_parcelSearchResult } from '@lanterds/types';
import { Tooltip } from '@mui/material';
import React from 'react';
import { Link } from 'react-router-dom';
import InfoTwoToneIcon from '@mui/icons-material/InfoTwoTone';
import WarningTwoToneIcon from '@mui/icons-material/WarningTwoTone';
import { closeSnackbar } from 'notistack';

type ParcelCodeV2Props = {
    parcelInfo: v2_parcelSearchResult;
    results: v2_parcelSearchResult[];
};

export const ParcelCode = ({ parcelInfo, results }: ParcelCodeV2Props) => {
    const { parcelCode, possessionDateUtc, deliveryDateUtc, asnDateUtc, customer, deliveryLocationAlert } = parcelInfo;
    const queryDate = possessionDateUtc ?? deliveryDateUtc ?? asnDateUtc;

    let detailUrl = '';

    const enoughDetailToMakeDetailURL =
        !!parcelCode &&
        parcelCode?.toUpperCase() !== 'NULL' &&
        !!queryDate &&
        !!customer?.fmtpId &&
        String(customer?.fmtpId)?.toUpperCase() !== 'NULL' &&
        String(customer?.fmtpId)?.toUpperCase() !== 'UNKNOWN';

    if (enoughDetailToMakeDetailURL) {
        const [encodedParcelCode, encodedDate, encodedCustomerFMTPID] = [
            parcelCode,
            new Date(queryDate).toISOString(),
            customer.fmtpId,
        ].map((params) => encodeURIComponent(params));

        detailUrl = `/parcel/${encodedParcelCode}/${encodedDate}/${encodedCustomerFMTPID}`;
    }

    return (
        <>
            {deliveryLocationAlert && (
                <Tooltip arrow title="Delivery location does not match expected delivery destination." placement="top">
                    <WarningTwoToneIcon />
                </Tooltip>
            )}
            {detailUrl && (
                <Link to={detailUrl} state={{ from: 'parcelCode', previousResults: results }} onClick={() => closeSnackbar()}>
                    {parcelCode}
                </Link>
            )}
            {!detailUrl && (
                <>
                    <Tooltip
                        arrow
                        title="This parcel does not have enough information for us to reliably fetch details."
                        placement="top"
                    >
                        <InfoTwoToneIcon />
                    </Tooltip>{' '}
                    {parcelCode}
                </>
            )}
        </>
    );
};
